import { render } from "./price_c_set.vue?vue&type=template&id=3900951e&scoped=true"
import script from "./price_c_set.vue?vue&type=script&lang=js"
export * from "./price_c_set.vue?vue&type=script&lang=js"

import "./price_c_set.vue?vue&type=style&index=0&id=3900951e&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3900951e"]])

export default __exports__